import VideoSB, { VideoSBProps } from '@/components/atoms/video/VideoSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

export interface VideoBlockProps {
  video: VideoSBProps;
  header?: BlockHeader;
}

export function VideoBlockStrapi({
  block,
  ...rest
}: BlockComponentModel<VideoBlockProps>) {
  const { video, header } = block;

  return (
    <BlockWrapper {...rest}>
      <div data-tracker-section={SECTION_NAMES.VIDEO_BLOCK}>
        <BlockHeaderContent {...header}>
          <VideoSB block={video} />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
